<template>
  <v-dialog v-model="open" fullscreen>
    <v-card>
      <template v-if="!displayResult">
        <v-card-title>
          <v-layout>
          <div>{{$t('checkin.image_crop.crop_tip')}}</div>
          <v-btn style="margin-left: auto;" icon @click="open = false"><v-icon>clear</v-icon></v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
        <cropper
          ref="cropper"
          class="cropper"
          :src="base64Image"
          :stencil-props="{
            aspectRatio: isCard ? 16 / 10 : null,
            movable: true,
            resizable: true,
            imageRestriction: 'stencil'
          }"
        />
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn class="ma-2" color="secondary" text @click="rotate"><v-icon class="mr-2">mdi-rotate-right</v-icon>{{$t('checkin.image_crop.actions.rotate')}}</v-btn>
            <v-btn class="ma-2" color="primary" @click="cropImage"><v-icon class="mr-2">mdi-crop</v-icon>{{$t('checkin.image_crop.actions.crop_image')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-title>
          <v-layout>
          <div>{{$t('checkin.image_crop.confirm')}}</div>
          <v-btn style="margin-left: auto;" icon @click="open = false"><v-icon>clear</v-icon></v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
        <v-img height="300" contain :src="resultURL"/>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn class="ma-2" text color="secondary" @click="displayResult = false"><v-icon class="mr-2">mdi-crop</v-icon>{{$t('checkin.image_crop.actions.edit_again')}}</v-btn>
            <v-btn class="ma-2" outlined color="primary" @click="updateImage()">{{$t('actions.continue')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </template>
      <v-alert :value="true" type="info" class="info ma-3" color="info-text" text>{{$t('checkin.image_crop.instructions')}}</v-alert>
    </v-card>
  </v-dialog>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
export default {
  props: {
    base64Image: String,
    triggerOpen: Date,
    isCard: Boolean,
  },
  data () {
    return {
      displayResult: false,
      result: null,
      resultURL: null,
      open: false,
    }
  },
  methods: {
    cropImage () {
      const { canvas } = this.$refs.cropper.getResult()
      const context = this
      canvas.toBlob((blob) => {
        context.result = blob
      }, 'image/jpeg')
      this.resultURL = canvas.toDataURL(
        'image/jpeg'
      )
      this.displayResult = true
    },
    rotate () {
      this.$refs.cropper.rotate(90)
    },
    updateImage () {
      this.$emit('change', { file: this.result, dataURL: this.resultURL })
      this.result = null
      this.resultURL = null
      this.open = false
      this.displayResult = false
    },
  },
  components: {
    Cropper,
  },
  watch: {
    triggerOpen () {
      this.open = true
    },
    open () {
      if (!this.open) {
        this.displayResult = false
        this.result = null
        this.resultURL = null
      }
    },
  },
}
</script>

<style scoped>
.cropper {
  border: solid 1px #EEE;
  width: 100%;
}
</style>
